import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import Transition from 'components/utils/transition';
import Tooltip from './tooltip';

export default class Block extends Component {
    static propTypes = {
        block: ImmutablePropTypes.map.isRequired,
        rootWidth: PropTypes.number.isRequired,
        tooltipVisible: PropTypes.bool.isRequired,
        tooltipExpanded: PropTypes.bool.isRequired,
        tooltipAnimation: PropTypes.bool.isRequired,
        tooltipOpenDown: PropTypes.bool.isRequired,
        showTooltip: PropTypes.func.isRequired,
        hideTooltip: PropTypes.func.isRequired,
        expandTooltip: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        onEntityClick: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.block !== this.props.block
            || nextProps.rootWidth !== this.props.rootWidth
            || nextProps.tooltipVisible !== this.props.tooltipVisible
            || nextProps.tooltipExpanded !== this.props.tooltipExpanded
            || nextProps.tooltipAnimation !== this.props.tooltipAnimation
            || nextProps.tooltipOpenDown !== this.props.tooltipOpenDown
            || nextProps.showTooltip !== this.props.showTooltip
            || nextProps.hideTooltip !== this.props.hideTooltip
            || nextProps.expandTooltip !== this.props.expandTooltip
            || nextProps.onClick !== this.props.onClick
            || nextProps.onEntityClick !== this.props.onEntityClick;
    }

    @autobind
    handleClick() {
        if (!this.isTouch) {
            this.props.onClick(this.props.block);
            if (this.props.tooltipVisible) this.props.hideTooltip(this.props.block);
        }
    }

    @autobind
    handleMouseEnter() {
        if (!this.isTouch) this.props.showTooltip(this.props.block);
    }

    @autobind
    handleMouseLeave() {
        if (!this.isTouch) this.props.hideTooltip(this.props.block);
    }

    @autobind
    handleTouchStart() {
        this.isTouch = true;
        if (!this.props.tooltipVisible) {
            this.ignoreOverlayClick = true;
            this.props.showTooltip(this.props.block);
        }
    }

    @autobind
    handleOverlayClick() {
        if (this.ignoreOverlayClick) this.ignoreOverlayClick = false;
        else this.props.hideTooltip(this.props.block);
    }

    @autobind
    handleMoreClick() {
        this.props.expandTooltip(this.props.block);
    }

    @autobind
    handleEntityClick(entity) {
        this.props.hideTooltip(this.props.block);
        this.props.onEntityClick(entity, this.props.block);
    }

    render() {
        const {block, rootWidth} = this.props;
        const {tooltipVisible, tooltipExpanded, tooltipAnimation, tooltipOpenDown} = this.props;
        const entities = block.get('entities');

        // Exponential function to accent weights near 1
        const bgStyle = {opacity: ((4 ** block.get('weight')) - 1) / 3};
        const bgClassName = classNames(
            'cielo24-vwrap-bg',
            {
                'cielo24-vwrap-active': entities.size,
                'cielo24-vwrap-hover': tooltipVisible,
            },
        );

        return (
            <div
                className='cielo24-vwrap-block'
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                onTouchStart={this.handleTouchStart}
            >
                <div className={bgClassName} style={bgStyle} onClick={this.handleClick} />
                <div
                    className={classNames(
                        'cielo24-vwrap-overlay',
                        {'cielo24-vwrap-visible': tooltipVisible && entities.size})}
                    onClick={this.handleOverlayClick}
                />
                <Transition name='tooltip' disabled={!tooltipAnimation}>
                    {tooltipVisible && entities.size > 0 && (
                        <Tooltip
                            entities={entities}
                            onMoreClick={this.handleMoreClick}
                            onEntityClick={this.handleEntityClick}
                            rootWidth={rootWidth}
                            visible={tooltipVisible}
                            expanded={tooltipExpanded}
                            openDown={tooltipOpenDown}
                        />
                    )}
                </Transition>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/heatmap/block.js